import { render, staticRenderFns } from "./safeItemCheckActivityResUp.vue?vue&type=template&id=4c6a6a0c&scoped=true"
import script from "./safeItemCheckActivityResUp.vue?vue&type=script&lang=js"
export * from "./safeItemCheckActivityResUp.vue?vue&type=script&lang=js"
import style0 from "./safeItemCheckActivityResUp.vue?vue&type=style&index=0&id=4c6a6a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a6a0c",
  null
  
)

export default component.exports